module.exports = __webpack_public_path__ + "static/media/FazzNeue-Heavy.3228dce7.ttf";